import { cssVar } from "@chakra-ui/theme-tools";
import { shadowsBase, spacing6x, spacing10x } from "@airhelp/design-tokens";
const $width = cssVar("switch-track-width");
const $height = cssVar("switch-track-height");
const baseStyleTrack = {
    background: "greyscale.300",
    borderRadius: "18px",
    padding: "unset",
    transitionProperty: "common",
    transitionDuration: "fast",
    _hover: {
        background: { md: "primary.300" },
        _checked: {
            background: { md: "primary.600" },
        },
    },
    _active: {
        background: "greyscale.500",
        _checked: {
            background: "primary.700",
        },
    },
    _focus: {
        boxShadow: "none",
    },
    _disabled: {
        background: "greyscale.400",
        _hover: {
            background: "greyscale.400",
        },
        _active: {
            background: "greyscale.400",
        },
        _checked: {
            background: "greyscale.300",
            _hover: {
                background: "greyscale.300",
            },
            _active: {
                background: "greyscale.300",
            },
        },
    },
    _checked: {
        background: "primary.500",
    },
};
const baseStyleThumb = {
    background: "greyscale.100",
    boxShadow: shadowsBase,
    width: "22px",
    height: "22px",
    position: "absolute",
    top: "1px",
    left: "1px",
};
const sizes = {
    md: {
        container: {
            [$width.variable]: spacing10x,
            [$height.variable]: spacing6x,
        },
    },
};
const defaultProps = {
    size: "md",
};
const baseStyle = {
    track: baseStyleTrack,
    thumb: baseStyleThumb,
};
const Switch = {
    baseStyle,
    sizes,
    defaultProps,
};
export default Switch;
